import Vue from 'vue'
import i18next from 'i18next'
import VueI18Next from '@panter/vue-i18next'
import Backend from 'i18next-xhr-backend'

Vue.use(VueI18Next)

i18next.use(Backend)
    .init({
    lng:  localStorage.getItem('language') || 'en',
        fallbackLng: 'en',
   backend: {
        loadPath: '/i18n/{{lng}}.json',
   } })

const i18n = new VueI18Next(i18next)

export default i18n
